import { Injectable } from '@angular/core';
import { RestService } from 'src/app/Services/Rest/rest.service';
import { login_body, getOTP_body } from 'src/app/common';
import { commonConstants, RoutesAll, RequestURL, Cookies, lender } from 'src/app/Constants/app.constants';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

export class GenerateOTP {
  constructor(
    public user_name: string = '',
  ) { }
}




@Injectable()
export class BorrowerService {

  dialogDataForAutomaticActivityModel : any;
  constructor(private restService: RestService, private router: Router,
    private httpClient: HttpClient, protected keycloakAngular: KeycloakService) { }

  getBorrowerDetails(requestURL: any, cb: any) {
    let customHttpHeader= {
      headers: new HttpHeaders({
          'Content-Type': 'text/plain',
        //  'client-security-token': apiAuthToken 
      })
    };
    this.restService.getRestCall(requestURL, (data: any) => {
      cb(data);
    }, customHttpHeader);
  };

  generateOTP(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //  'client-security-token': apiAuthToken 
      })
    };
    this.restService.postRestCall(reuqestBody, requestURL, (data: any) => {
      cb(data);
    }, customHttpHeader);
  }

  resendOtp(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //  'client-security-token': apiAuthToken 
      })
    };
    this.restService.postRestCall(reuqestBody, requestURL, (data: any) => {
      cb(data);
    }, customHttpHeader);
  }

  submitOtp(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //  'client-security-token': apiAuthToken 
      })
    };
    this.restService.postRestCall(reuqestBody, requestURL, (data: any) => {
      cb(data);
    }, customHttpHeader);
  }

  submitConsentCapture(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //  'client-security-token': apiAuthToken 
      })
    };
    this.restService.postRestCall(reuqestBody, requestURL, (data: any) => {
      cb(data);
    }, customHttpHeader);
  }

  fetchStatus(requestBody: any, requestURL: any, cb: any){
    let customHttpHeader = {
      headers: new HttpHeaders({
        			'Content-Type': 'application/json',
      })
    };
    this.restService.postRestCall(requestBody, requestURL, (data: any) => {
      cb(data);
    }, customHttpHeader);

  }
}